import { forEach } from 'lodash';
import { IFilterStatus } from '../../components/filters/newFilters/filterStatus';
import { IFilterResult, IFilterOption, getFilterOptionId, getFilterOptionDisplay, removeFilterItem } from '../../components/filters/filterLib';

export function getNewStatusFilters(currentFilter: IFilterResult): IFilterStatus[] {
  const statuses: IFilterStatus[] = [];
  forEach(currentFilter, (selectedItems: IFilterOption[] | boolean, groupId: string) => {
    if (typeof selectedItems === 'boolean') return;
    forEach(selectedItems, (item: IFilterOption) => {
      const itemId = getFilterOptionId(item);
      const itemDisplay = getFilterOptionDisplay(item);
      statuses.push({ id: itemId, display: itemDisplay, group: groupId });
    });
  });
  return statuses;
}

export function handleNewFilterRemoved(
  currentFilter: IFilterResult,
  id: string,
  item: IFilterStatus,
  setCurrentFilter: (filters: IFilterResult) => void
): void {
  const newFilters = removeFilterItem(currentFilter, { group: item.group, id });
  setCurrentFilter(newFilters);
}
